import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Jignesh Kotadiya </span>
            from <span className="purple"> Nashik, India.</span>
            <br />
            I'm a software, DevOps and AI/automation engineer with
            <span className="purple"> 7+ years </span> of experience, working
            remote-first with teams and clients worldwide.
            <br />
            I build <span className="purple"> AI agents and RAG systems</span>,
            Python backends (Django/DRF, FastAPI), and the AWS cloud
            infrastructure that runs them — and I'm an
            <span className="purple"> AWS Certified DevOps </span> engineer.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Building side-projects & automations
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring new AI tools
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Aim to develop innovations that truly matter."{" "}
          </p>
          <footer className="blockquote-footer">Jignesh Kotadiya</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
